"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";

import { Button } from "components/atoms/Button/Button";

import { SLUGS } from "consts";
import { IconType } from "@types";

import s from "./HeroCta.module.scss";

export const HeroCta: FC = () => {
  const t = useTranslations("common");

  return (
    <div className={s.Cta}>
      <div className={s.CtaContent}>{t("find-office-nearby")}</div>
      <Button
        label={t("contact-us")}
        link={{ href: SLUGS.contactGeneral }}
        icon={IconType.CaretFilled}
      />
    </div>
  );
};
